<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import WeekDay from "@/view/components/campaigns/WeekDay.vue";
import {
  addOtherCampaignConfiguration,
  getOtherCampaign,
  updateOtherCampaign
} from "@/api/campaigns";
import moment from "moment";
import swal from "sweetalert";
const startOfMonth = moment()
  .clone()
  .startOf("month")
  .format("YYYY-MM-DD");
const endOfMonth = moment()
  .clone()
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "other-campaign-dialog",
  components: {
    VueCtkDateTimePicker,
    WeekDay
  },
  props: ["show", "locations", "campaign_id", "location_groups"],
  data() {
    return {
      // locations: [],
      form: {
        name: "",
        start: startOfMonth,
        end: endOfMonth,
        repeat_on: "specific",
        selectedDays: [],
        // specific_days: [],
        // daily: [],
        // selectedItems: [],
        schedules: [],
        locations: [],
        location_groups: [],
        selectedLocationOrGroup: "locations",
        // selectedLocationGroupItems: [],
        type: "other-campaign",
        date_ended: moment().format("YYYY-MM-DD"),
        date_start: moment().format("YYYY-MM-DD"),
      },
      selectedItems: [],
      selectedDays: [],
      dtpicker: { start: '', end: ''
      },
      daysOptions: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
      options: [
        { value: "specific", text: "Specific days" },
        { value: "daily", text: "Daily" },
        { value: "does not repeat", text: "Does not repeat" },
        { value: "weekends", text: "Weekend (Satuday and Sunday)" }
      ],
      itemOptions: [],
      itemOptions2: [
        {
          language: "Select/Unselect All",
          libs: [
            { name: "SD Aioli", id: 15 },
            { name: "SD Chicken - Side", id: 19 }
          ]
        }
      ],
      savedItem: null,
      schedules: [],
      location_id: null,
      locationSelected: null,
      menu_item_enabled: true,
      propSched: [],
      maxDisplay: 1,
      searchTerm: null,
      locationsCopy: [],
      locationsOptions: [],
      minDate: "",
      maxDate: "",
      snackbar: false,
      text: "Loading campaigns...",
      timeout: 2000,
       locationOrGroupOptions: [
        { text: "Locations", value: "locations"},
        { text: "Location Groups", value: "location_groups"}
      ],
      selectedLocationGroups: [],
      searchLocationGroupTerm: null,
      selectedLocationGroupItems: [],
      locationGroupsCopy: [],
      locationGroupsOptions: [],
    };
  },
  async mounted() {
    // console.log("Controls Dialog", this.campaign_id);
    this.setLocations();
    this.setLocationGroups();
    if (this.locations && this.locations.length > 0 && !this.campaign_id) {
      setTimeout(() => {
        this.toggle();
      }, 500);
    }
    if (this.campaign_id) {
      let item = await getOtherCampaign(this.campaign_id);
      // setTimeout(() => {
      //   console.log("loading data");
      // }, 2000);
      // console.log("item", item);
      this.form.name = item.name;
      this.form.start = item.date_start ? moment(item.date_start).format("YYYY-MM-DD") : startOfMonth;
      this.form.end = item.date_ended ? moment(item.date_ended).format("YYYY-MM-DD") : endOfMonth;
      this.form.date_start = item.date_start ? moment(item.date_start).format("YYYY-MM-DD") : startOfMonth;
      this.form.date_ended =item.date_ended ? moment(item.date_ended).format("YYYY-MM-DD") : endOfMonth;
      this.dtpicker.start = this.form.start;
      this.dtpicker.end = this.form.end;
      this.form.repeat_on = item.repeat_on;
      this.form.selectedDays = item.selectedDays;
      this.selectedDays = this.form.selectedDays;
      this.form.schedules = item.schedules;
      this.propSched = item.schedules;
      if (item.all_locations && item.all_locations.length > 0) {
        let data = [];
        for (let i = 0; i < item.all_locations.length; i++) {
          let location = item.all_locations[i];
          // console.log(location);
          data.push(location.id);
        }
        this.form.locations = data;
      }
      if (item.location_groups && item.location_groups.length > 0) {
        this.form.selectedLocationOrGroup = "location_groups";
        let location_group_data = [];
        for (let i = 0; i < item.location_groups.length; i++) {
          let location_group = item.location_groups[i];
          location_group_data.push(location_group);
        }
        this.form.location_groups = location_group_data;
        
      }
      // console.log("this.form", this.form);
    }
  },
  computed: {
    visible() {
      return this.show;
    },
    likesAllItems() {
      return this.form.locations.length === this.locationsOptions.length;
    },
    likesSomeItem() {
      return this.form.locations.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllGroupItems() {
      return this.form.location_groups.length === this.locationGroupsOptions.length;
    },
    likesSomeGroupItem() {
      return this.form.location_groups.length > 0 && !this.likesAllGroupItems;
    },
    groupicon() {
      if (this.likesAllGroupItems) return "mdi-close-box";
      if (this.likesSomeGroupItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    campaignId() {
      return this.campaign_id ? `#${this.campaign_id}` : "";
    }
  },
  watch: {
    dtpicker(newVal) {
      console.log(newVal)
      if (newVal == undefined) {
        // let today = moment().format("YYYY-MM-DD");
        // this.dtpicker = { start: today, end: today };
      }else{
        this.form.start = newVal.start;
        this.form.end = newVal.end;
        this.form.date_start = newVal.start;
        this.form.date_ended = newVal.end;
      }

    },
    selectedDays(newVal) {
      this.form.selectedDays = newVal;
    },
    selectedItems(newVal) {
      this.form.selectedItems = newVal;
    },
    // selectedLocationGroupItems(newVal) {
    //   this.form.selectedLocationGroupItems = newVal;
    // }
    "form.selectedLocationOrGroup"(){
      console.log("form selectedLocationOrGroup",this.form.selectedLocationOrGroup);
      // if(this.form.selectedLocationOrGroup == 'location_groups'){
      //   this.selectedItems = []; 
      //   this.form.locations = [];
      // }
      // else if(this.form.selectedLocationOrGroup == 'locations'){
      //   this.selectedLocationGroupItems =[];
      //   this.form.location_groups = [];
      // }
    },
  },
  methods: {
    whenDtClosed(){
      if(this.dtpicker.end == null && this.dtpicker.start != null) {
        this.dtpicker.end = this.dtpicker.start
      }
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.form.locations = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item.value);
          }
          this.form.locations = data;
        }
      });
    },
    setLocations() {
      this.locationsOptions = [
        ...this.locations.map(list => {
          return {
            value: list.id,
            text: `${list.name} ${list.full_address}`
          };
        })
      ];
      this.locationsCopy = [...this.locationsOptions];
    },
    filterLocations() {
      if (!this.searchTerm || this.locationsOptions.length == 0) {
        this.locationsOptions = this.locationsCopy;
      }
      this.locationsOptions = this.locationsOptions.filter(item => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
      this.searchTerm = null
      this.filterLocations()
    },
    setLocationGroups() {
      this.locationGroupsOptions = [
        ...this.location_groups.map((list) => {
          return {
            value: list.id,
            text: `${list.name}`,
            name: list.name
          };
        }),
      ];
      this.locationGroupsCopy = [...this.locationGroupsOptions];
    },
    toggleLocationGroup() {
      this.$nextTick(() => {
        if (this.likesAllGroupItems) {
          // this.selectedLocationGroupItems = [];
          this.form.location_groups = [];
        } else {
          // let data = [];
          let form_data = [];
          for (let i = 0; i < this.locationGroupsOptions.length; i++) {
            let item = this.locationGroupsOptions[i];
            // data.push(item);
            form_data.push(item.value);
          }
          // this.selectedLocationGroupItems = data;
          this.form.location_groups = form_data;
        }
      });
    },
    filterLocationGroups() {
      if (!this.searchLocationGroupTerm || this.locationGroupsOptions.length == 0) {
        this.locationGroupsOptions = this.locationGroupsCopy;
      }
      this.locationGroupsOptions = this.locationGroupsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchLocationGroupTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationGroupBlur(){
      this.searchLocationGroupTerm = null
      this.filterLocationGroups()
    },
    async onSubmit() {
      // Saving form data
      let result = null;
      this.form.date_start = moment(this.form.date_start);
      this.form.date_ended = moment(this.form.date_ended);
      const payload = JSON.parse(JSON.stringify(this.form));
      // console.log("payload", payload);
      if (this.campaign_id) {
        if (this.dtpicker.start == '' || this.dtpicker.end == '' || payload.name == ''){
          swal('Please fill up the required field');
          return false
        } else if(payload.selectedLocationOrGroup == 'location_groups' && payload.location_groups.length <= 0){
          swal('Please select Location group');
          return false
        }else if(payload.selectedLocationOrGroup == 'locations' && payload.locations.length <= 0){
          swal('Please select Location');
          return false
        }
        result = await updateOtherCampaign(this.campaign_id, payload);
        // this.text = "Other campaign has been updated";
        swal("Other Campaign updated.");
      } else {
        if (this.dtpicker.start == '' || this.dtpicker.end == '' || payload.name == ''){
          swal('Please fill up the required field');
          return false
        } else if(payload.selectedLocationOrGroup == 'location_groups' && payload.location_groups.length <= 0){
          swal('Please select Location group');
          return false
        }else if(payload.selectedLocationOrGroup == 'locations' && payload.locations.length <= 0){
          swal('Please select Location');
          return false
        }
        result = await addOtherCampaignConfiguration(payload);
        // this.text = "Other campaign type created";
        swal("Other Campaign created.");
      }
      // console.log("result", result);
      if (result) {
        // this.snackbar = true;
        this.$store.dispatch("getCampaignList");
        this.close();
      } else {
        this.text = "Oops there's a problem in creating a campaign";
        swal("Something went wrong. Please try again.");
        this.snackbar = true;
      }
    },
    handleRepeatOn() {
      let item = window.localStorage.getItem("other-campaign");
      this.savedItem = JSON.parse(item);
      let defaultDays = [];
      if (this.form.repeat_on === "specific") {
        defaultDays = [];
      }
      if (this.form.repeat_on === "daily") {
        defaultDays = [];
      }
      if (this.form.repeat_on === "does not repeat") {
        defaultDays = [];
      }
      if (this.form.repeat_on === "weekends") {
        defaultDays = ["sat", "sun"];
      }
      this.selectedDays = defaultDays;
      // this.form.schedules = [];
      // this.form.schedules =
      //   this.savedItem && this.savedItem.schedules
      //     ? this.savedItem.schedules
      //     : [];
      // this.handleChanges();
    },
    handleChanges() {
      this.$store.commit("setHasChanges", true);
      this.$store.commit("setCampaignSavedData", this.form);
      this.$emit("input", true);
    },
    handleWeekDayChange() {
      this.$nextTick(() => {
        var elements = document.getElementsByClassName("week-time");
        let data = [];

        Array.from(elements).forEach(element => {
          console.log('value111:',element)
          data.push({
            day: element.getAttribute("day"),
            timepos: element.getAttribute("timepos"),
            value: element.value
          });
        });
        this.form.schedules = JSON.parse(JSON.stringify(data));
        this.handleChanges();
      });
    },
    handleDailyChanges() {
      this.$nextTick(() => {
        let elements = document.getElementsByClassName("week-time");
        let data = [];
        Array.from(elements).forEach(element => {
          console.log('value222:',element);
          data.push({
            day: element.getAttribute("day"),
            timepos: element.getAttribute("timepos"),
            value: element.value
          });
        });
        // this.form.specific_days = [];
        // this.form.daily = JSON.parse(JSON.stringify(data));
        this.form.schedules = JSON.parse(JSON.stringify(data));
        this.handleChanges();
      });
    },
    locationChange() {
      if (this.locationSelected) {
        this.selectedItems = [];
        this.$store.commit("setSelectedLocations", this.locationSelected);
        this.$store.dispatch("getInitialMenuItems");
        this.menu_item_enabled = false;
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent scrollable width="40%">
    <v-card>
      <v-card-title class="headline">
        Other Campaign {{ campaignId }}
        <span
          style="float: right; position: absolute; right: 20px; color: #999; cursor:pointer"
          @click="close"
        >
          x</span
        >
      </v-card-title>
      <v-card-text>
        <div class="mt-5 mb-5">
          If you ran any other type of campaign, set it up here so we can
          measure the ROI. Think of things like billboards, radio, TV
          commercials, or other marketing spend that wasn't run natively through
          our platform.
        </div>
        <!-- Form -->
        <v-form
          v-on:submit.prevent="onSubmit"
          method="POST"
          accept-charset="UTF-8"
          enctype="multipart/form-data"
          id="mainForm"
        >
          <v-container>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-campaign-name"
                  label="Campaign Name:"
                  label-for="input-campaign-name"
                >
                  <b-form-input
                    id="input-campaign-name"
                    v-model="form.name"
                    type="text"
                    required
                    placeholder="Type desired campaign name"
                    @change="handleChanges"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p><strong>Campaign Specifics:</strong></p>
                <p>
                  Detail specifics about your campaign, including periods of
                  time or items that were marketed.
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="6">
                <b-form-group label="Date range">
                  <VueCtkDateTimePicker
                    @is-hidden="whenDtClosed()"
                    id="other-campaign-dtpicker"
                    v-model="dtpicker"
                    format="YYYY-MM-DD"
                    formatted="ll"
                    label="Select date range"
                    :min-date="minDate"
                    :max-date="maxDate"
                    range
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6">
                <b-form-group label="Repeat on">
                  <b-form-select
                    v-model="form.repeat_on"
                    :options="options"
                    required
                    @change="handleRepeatOn"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.repeat_on !== 'daily'">
              <b-col>
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    v-model="selectedDays"
                    :options="daysOptions"
                    :aria-describedby="ariaDescribedby"
                    style="text-transform: capitalize;"
                    inline
                  ></b-form-checkbox-group>
                </b-form-group>
                <div class="mt-1">
                  <template v-for="item in selectedDays">
                    <week-day
                      :item="item"
                      :key="item"
                      :schedules="propSched"
                      @input="handleWeekDayChange"
                    ></week-day>
                  </template>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="form.repeat_on === 'daily'">
              <b-col>
                <week-day
                  :item="form.repeat_on"
                  :key="form.repeat_on"
                  :schedules="propSched"
                  @input="handleDailyChanges"
                ></week-day>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="mr-2 mt-6" style="width: 200px;">
                  <v-select
                    v-model="form.selectedLocationOrGroup"
                    :items="locationOrGroupOptions"
                    required
                    dense
                    outlined
                    background-color="#ffffff"
                    height="42"
                    :menu-props="{ top: false, offsetY: true }"
                  ></v-select>
                </div>
                <p>
                  <strong  v-if="form.selectedLocationOrGroup == 'locations'">
                    Select the locations where you ran this campaign.
                  </strong>
                  <strong  v-if="form.selectedLocationOrGroup == 'location_groups'">
                    Select the location groups where you ran this campaign.
                  </strong>
                </p>
                <v-select
                  v-if="form.selectedLocationOrGroup == 'locations'"
                  v-model="form.locations"
                  :items="locationsOptions"
                  multiple
                  required
                  dense
                  outlined
                  background-color="#ffffff"
                  height="42"
                  label="Location"
                >
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                          v-model="searchTerm"
                          placeholder="Search"
                          @input="filterLocations"
                          @blur="filterLocationsBlur"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                    <v-list-item ripple @click="toggle">
                      <v-list-item-action>
                        <v-icon
                          :color="
                            form.locations.length > 0 ? 'indigo darken-4' : ''
                          "
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Select All
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template
                    v-if="form.locations.length > 1"
                    v-slot:selection="{ item, index }"
                  >
                    <span v-if="index === maxDisplay">
                      {{ form.locations.length }} locations selected
                    </span>
                  </template>
                </v-select>

                <v-select
                  v-if="form.selectedLocationOrGroup == 'location_groups'"
                  v-model="form.location_groups"
                  :items="locationGroupsOptions"
                  label="Group Location"
                  required
                  dense
                  outlined
                  background-color="#ffffff"
                  height="42"
                  return-object
                  style="position: relative; z-index: 4;"
                  multiple
                  :menu-props="{ top: false, offsetY: true }"
                >
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                          v-model="searchLocationGroupTerm"
                          placeholder="Search"
                          @input="filterLocationGroups"
                          @blur="filterLocationGroupBlur"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                    <v-list-item ripple @click="toggleLocationGroup">
                      <v-list-item-action>
                        <v-icon
                          :color="form.location_groups.length > 0 ? 'indigo darken-4' : ''"
                        >
                          {{ groupicon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Select All
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template
                    v-if="form.location_groups.length > 1"
                    v-slot:selection="{ item, index }"
                  >
                    <span v-if="index === maxDisplay">
                      {{ form.location_groups.length }} location groups selected
                    </span>
                  </template>
                  <template slot="item" slot-scope="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                      <v-list-item-action>
                        <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.name }}
                        </v-list-item-title>
                        <!-- <v-list-item-subtitle>
                          {{ item.full_address }}
                        </v-list-item-subtitle> -->
                      </v-list-item-content>
                    </v-list-item>
                  </template>
              </v-select>
              </b-col>
            </b-row>
          </v-container>
        </v-form>
        <!-- End Form -->
      </v-card-text>
      <v-card-actions class="p-5">
        <v-spacer></v-spacer>
        <v-btn class="mr-4" depressed tile @click="close">
          Close
        </v-btn>
        <v-btn class="mr-4" @click="onSubmit" depressed color="primary">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>
